<template>
  <div class="radiusSetting">
    <div class="radiusSettingTitle">半径設定</div>
    <div class="radiusSettingBody">
      <v-radio-group v-model="enableBulkSetting" :disabled="readonly">
        <div class="formGroup">
          <div class="formControl">
            <v-radio :value="true" label="半径一括設定" />
          </div>
          <div
            v-bind:class="{ inactive: !enableBulkSetting }"
            class="formControl flex"
          >
            <v-text-field
              v-model.number="radius"
              :disabled="!enableBulkSetting"
              :rules="[rules.required, rules.min, rules.max]"
              @wheel.prevent
              type="number"
              ><template v-slot:append-outer>
                <span>m</span>
              </template></v-text-field
            >
          </div>
          <div class="form-control">
            <v-radio :value="false" label="半径個別設定" />
          </div>
        </div>
      </v-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimulationContentDeliverySidebarRadiusSetting',
  props: {
    form: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    deliverySetting() {
      return this.form.deliverySetting
    },
    menuSetting() {
      return this.form.deliverySetting.menuSetting
    },
    rules() {
      return this.menuSetting.validations.radiusSetting
    },
    simulationLocationGroups() {
      return this.menuSetting.simulationLocationGroups
    },
    currentSelectedGroup() {
      const currentSelectedGroupId = 1
      return this.simulationLocationGroups.getGroup(currentSelectedGroupId)
    },
    enableBulkSetting: {
      get() {
        return this.menuSetting.enableBulkSetting
      },
      set(value) {
        this.menuSetting.setEnableBulkSetting(value)
      },
    },
    radius: {
      get() {
        return this.menuSetting.radius
      },
      set(radius) {
        this.menuSetting.updateRadius(radius)
      },
    },
  },
}
</script>

<style scoped>
.radiusSetting {
  padding: 5px 10px;
  width: 100%;
}

.radiusSettingTitle {
  padding-bottom: 10px;
}

.radiusSettingBody {
  padding-left: 10px;
  padding-bottom: 10px;
}

.formControl {
  align-items: center;
  margin-bottom: 10px;
}

.formControl.flex {
  display: flex;
}

.formControl.inactive ::v-deep .v-text-field__slot {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
